import { BaseTenantLinksDto } from '../../shared/dtos/base-tenant-links.dto';

/**
 * Transaction links DTO
 */
export class TransactionLinksDto extends BaseTenantLinksDto {
	rentalAgreementId?: number | null;
	rentalReservationId?: number | null;
	vehicleRoadTaxId?: number | null;
	vehicleRoadWorthyCheckId?: number | null;
	vehicleMaintenanceId?: number | null;
	vehicleInsuranceId?: number | null;
}
